export function planRange(start, end) {
    const format = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? value.split('-').reverse().join('.') : '—';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(end || '')) return format(start);
    const last = new Date(`${end}T00:00:00Z`); last.setUTCDate(last.getUTCDate() - 1);
    return `${format(start)} — ${format(last.toISOString().slice(0, 10))}`;
}

function signature(row) {
    // Group only identical alternatives. Notes and automatic tails can change
    // the decision even when employee and destination are the same.
    return JSON.stringify([Number(row.employee_id), row.state_type, row.building_id || null, row.object_group_id || null,
        row.planned_object_id || null, row.target_name, row.note || null, row.loupe_reason || null,
        row.date_precision || null, row.color || null, row.source_payload && row.source_payload.auto_unassigned || null]);
}

export function planGroups(conflicts) {
    const result = [];
    for (const original of conflicts) {
        const parts = original.id.split(':');
        const detail = {starts_on: parts[1], ends_on: parts[2], ...original.details};
        const conflict = {...original, details: detail};
        const candidates = conflict.candidates || [];
        const keys = candidates.map(signature);
        const unambiguous = new Set(keys).size === keys.length;
        const options = candidates.map((row, index) => ({key: unambiguous ? keys[index] : `record:${row.id}`, row}));
        const groupKey = unambiguous ? JSON.stringify(keys.slice().sort()) : conflict.id;
        const previous = result[result.length - 1];
        const item = {conflict, options};
        if (previous && detail.starts_on && previous.ends_on === detail.starts_on && previous.signature === groupKey
            && previous.allowed === conflict.allowed) {
            previous.ends_on = detail.ends_on; previous.items.push(item);
        } else result.push({id: conflict.id, signature: groupKey, starts_on: detail.starts_on, ends_on: detail.ends_on,
            allowed: conflict.allowed, options, items: [item]});
    }
    return result;
}

export function groupChoice(group, resolutions) {
    const keys = group.items.map(({conflict, options}) => {
        const chosen = resolutions[conflict.id];
        const option = chosen && chosen.fingerprint === conflict.fingerprint && options.find(option => String(option.row.id) === String(chosen.choice));
        return option ? option.key : null;
    });
    return keys[0] && keys.every(key => key === keys[0]) ? keys[0] : null;
}

export function employeePlanChoices(conflicts, employeeId) {
    return conflicts.map(conflict => ({conflict, candidates: (conflict.candidates || []).filter(row => Number(row.employee_id) === Number(employeeId))}))
        .filter(item => item.conflict.allowed && item.candidates.length === 1)
        .map(item => ({conflict: item.conflict, row: item.candidates[0]}));
}
